// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/scss/global.scss
// module id = 54
// module chunks = 0